export default "__VITE_ASSET__Bco32B7g__"